"use client";
import type { CSSProperties, ReactElement, RefObject } from "react";
import type { WitnessCardData } from "@/components/ui/Cwitnesscard";
import { Cwitnesscard } from "@/components/ui/Cwitnesscard";
import { CWITNESS_CARDS, CWITNESS_MOBILE_STICKY_CARD_HEIGHT, } from "./constants";
import { buildRightColumnStyle } from "./styles";
interface CwitnessRightColumnProps {
    isMobile: boolean;
    onCardClick: (card: WitnessCardData) => void;
    rightColumnRef: (element: HTMLDivElement | null) => void;
    scrollContainerRef: RefObject<HTMLDivElement | null> | undefined;
    vh: number;
}
export function CwitnessRightColumn({ isMobile, onCardClick, rightColumnRef, scrollContainerRef, vh, }: CwitnessRightColumnProps): ReactElement {
    const rightColumnStyle = buildRightColumnStyle({ isMobile, vh });
    const mobileCardStyle: CSSProperties | undefined = isMobile
        ? { height: CWITNESS_MOBILE_STICKY_CARD_HEIGHT }
        : undefined;
    return (
      <div data-el="Cwitness/RightColumn/Viewport" ref={rightColumnRef} style={rightColumnStyle}>
      {CWITNESS_CARDS.map((card, index) => (<Cwitnesscard key={card.id} data={card} isSticky={isMobile} isMobileMotion={isMobile} index={index} style={mobileCardStyle} layoutId={card.id} onClick={() => onCardClick(card)} scrollContainerRef={scrollContainerRef}/>))}
      </div>
    );
}
